import React, { useEffect, useRef, useState } from 'react';
import './createOrderform.css';
import InputTextBox from '../../components/InputTextBox/InputTextBox';
import Button from '../../components/Buttons/Button';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { Input, Select, Table, message, notification, Space, DatePicker, Divider, Popconfirm, Spin, Modal, Tooltip } from 'antd';
import { fetchClientIndegeneCurrency, fetchFinanacialSpoc, fetchGeographyCode, fetchClassCodes, fetchBuDepartmentSubDepartment, addOrUpdateWorkOrder, setWorkOrderModalIsOpen, getMultiYearDealDates, getCovertedCurrency } from '../../store/reducers/orderDashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import Checkbox from '../../components/CheckBox/checkbox';
import dayjs from 'dayjs';
import moment from 'moment';
import { Switch } from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import InvoiceScheduleModal from './InvoiceScheduleModal';

interface Props {
  onSubmit: () => void;
  onCancel: () => void;
  confirmPopUpData: any;
  selectedSOW: any;
}

interface DataType {
  bu: string;
  department: string;
  subDepartment: string;
  tcvSplit: string;
  primaryClassCode: boolean;

}
const dateFormat = 'YYYY-MM-DD';
const { RangePicker } = DatePicker;
const data: DataType[] = [];
// for (let i = 0; i < 20; i++) {
//   data.push({
//     key: i,
//     bu: `Bu ${i}`,
//     department: `Map Opportunity to create Order ID ${i}`,
//     subDepartment: `opportunityName ${i}`,
//     tcvSplit: `tcvSplit ${i}`,
//     primaryClassCode: false,
//   });
// }
const CreateOrderRequestForm: React.FC<Props> = ({ onSubmit, onCancel, confirmPopUpData,selectedSOW }) => {
  const dispatch = useDispatch();
  const selectRef = useRef<any>(null);
  const ref_reason = useRef<any>(null);
  const ref_netSuiteParentId = useRef<any>(null);
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [cofData, setCOFData] = useState<any>({});
  const [clientEntityDataList, setClientEntityDataList] = useState<any>([]);
  const [selectedClientEntity, setSelectedClientEntity] = useState<any>({});
  const [indegeneEntityList, setIndegeneEntityList] = useState<any>([]);
  const [selectedIndegeneEntity, setSelectedIndegeneEntity] = useState<any>("");
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [currencyList, setCurrencyList] = useState<any>([]);
  const [selectedCurrency, setSelectedCurrency] = useState<any>("");
  const [sowId, setSowId] = useState<any>('');
  const [sowName, setSowName] = useState<any>('');
  const [geographycode, setGeographycode] = useState<any>('');
  const [totalcontractvalue, setTotalcontractvalue] = useState<any>('');
  const [tcv_usd, setTcv_usd] = useState<any>('');
  const [financialspoclist, setFinancialspoclist] = useState<any>([]);
  const [financialspoc, setFinancialspoc] = useState<any>([]);
  const [classCode, setClassCode] = useState<any>('');
  const [primaryclasscode, setPrimaryclasscode] = useState<boolean>(false);
  const [buDatalist, setBuDatalist] = useState<any>([]);
  const [bulist, setBulist] = useState<any>([]);
  const [selectedBuData, setSelectedBuData] = useState<any>('');
  const [departmentList, setDepartmentList] = useState<any>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<any>('');
  const [subDepartmentList, setSubDepartmentList] = useState<any>([]);
  const [selectedSubDepartment, setSelectedSubDepartment] = useState<any>("");
  const [parentId, setParentId] = useState<any>("");
  const [buSecData, setBuSecData] = useState<any>([]);
  const [tcvSplit, setTcvSplit] = useState<any>("");
  const [buSecID, setBuSecID] = useState<any>("");
  const [cliententityrelatedfields, setCliententityrelatedfields] = useState<boolean>(true);
  const [burelatedfields, setBurelatedfields] = useState<boolean>(true);
  const [subDepartmentFiled, setSubDepartmentFiled] = useState<boolean>(true);
  const [yearsofDeal, setYearsofDeal] = useState<string>('');
  const [startDate, setStartDate] = useState<any>(new Date().toISOString());
  const [endDate, setEndDate] = useState<any>(new Date().toISOString());
  const multiyearDealcheckOptions = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }];
  const [multiyearDealcheck, setMultiyearDealcheck] = useState<string>('No');
  const [editConfirmpopup, setEditConfirmPopup] = useState<boolean>(true);
  const [visibleField, setvisibleField] = useState<boolean>(false);
  const [isCustomRangeDisabled, setIsCustomRangeDisabled] = useState<boolean>(true);
  const [isCustomDateRange, setIsCustomDateRange] = useState<boolean>(false);
  const [datetype, setDatetype] = useState<string>('');
  const datetypeOptions = [{ label: 'Fiscal Year', value: 'Fiscal Year' }, { label: 'Calender Year', value: 'Calender Year' }, { label: 'Custom Range', value: 'Custom Range' }];
  const [confirmeditsection, setConfirmeditsection] = useState<boolean>(false);
  const [noOfYearsOptions, setNoOfYearsOptions] = useState<any>([]);
  const [buSectionEditable, setBuSectionEditable] = useState<boolean>(true);
  const [netSuiteParentId, setNetSuiteParentId] = useState<any>("");
  const [reason, setReason] = useState<any>("");
  const [invoiceScheduleAvailable, setInvoiceScheduleAvailable] = useState<string>('No');
  const [invoiceSchedule, setInvoiceSchedule] = useState<any>(null);
  const [showInvoiceScheduleModal, setShowInvoiceScheduleModal] = useState<boolean>(false);
  const invoiceScheduleAvailableOptions = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }];

  const { confirm } = Modal; 
  const columns: ColumnsType<DataType> = [
    {
      title: 'Business Unit',
      width: 100,
      dataIndex: 'bu',
      key: 'bu',
      fixed: 'left',
    },
    {
      title: 'Department',
      width: 100,
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: 'Sub Department',
      dataIndex: 'subDepartment',
      key: 'subDepartment',
      width: 100,
    },
    {
      title: 'Class Code',
      dataIndex: 'classCode',
      key: 'classCode',
      width: 100,
    },
    {
      title: 'Primary Class Code',
      dataIndex: 'primaryClassCode',
      key: 'primaryClassCode',
      width: 100,
      render: (text: string, record: any) => {
        return (
          <>
            <span>{record.primaryClassCode ? 'Yes' : 'No'}</span>
          </>
        )
      }
    },
    {
      title: 'TCV Split',
      dataIndex: 'tcvSplit',
      key: 'tcvSplit',
      width: 100,
    },
    {
      title: 'Action',
      fixed: 'right',
      width: 85,
      render: (text: string, record: any) => {
        return (
          <>
            <a className='maplink' onClick={() => editBusec(record)}>EDIT  </a>
            <Popconfirm title="Are you sure you want to delete?" onConfirm={()=>deleteBuSec(record)} okText="Yes" cancelText="No">
                <a className='maplink' style={{ 'paddingLeft': '5px' }} onClick={() => null}>DELETE</a>
            </Popconfirm>
            
            </>
        )
      }
    },
  ];
  const isSubmitbuttonEnabled = () => {
    if (selectedClientEntity && selectedIndegeneEntity && selectedCurrency && sowId && sowName && geographycode && financialspoc.length > 0 && totalcontractvalue && buSecData.length > 0) {
      if (invoiceScheduleAvailable === 'Yes' && !invoiceSchedule) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
  const editBusec = (item: any) => {
    if(!buSectionEditable){
      message.warning("One Combination of BU, Dept., Sub Dept. is in Edit Stage.");
      return;
    }
    if (item.id) {
      setBuSecID(item.id);
    }
    else {
      setBuSecID("");
    }
    setBuSectionEditable(false);
    setSelectedBuData(item.bu);

    setSelectedDepartment(item.department);
    setDepartmentList(Object.keys(buDatalist[item.bu]));
    setSelectedSubDepartment(item.subDepartment);
    setClassCode(item.classCode);
    setPrimaryclasscode(item.primaryClassCode);
    setSubDepartmentList(buDatalist[item.bu][item.department]);
    if (item.tcvSplit === "0") {
      setTcvSplit("");
    } else {
      setTcvSplit(item.tcvSplit);
    }
    setClassCode(item.classCode);
    setPrimaryclasscode(item.primaryClassCode);
    let filterData = buSecData.filter((data: any) => {
      if (!(data.bu == item.bu && data.department == item.department && data.subDepartment == item.subDepartment)) {
        return true;
      } else {
        return false;
      }
    });
    setBuSecData(filterData);
  };
  //switch function
  const onChange = (checked: boolean) => {
    if (checked == true) {
      setConfirmeditsection(true);
      setEditConfirmPopup(true);
    } else {
      setConfirmeditsection(false);
    }
  };
  const deleteBuSec = (item: any) => {
    let filterData = buSecData.filter((data: any) => {
      if (!(data.bu == item.bu && data.department == item.department && data.subDepartment == item.subDepartment)) {
        return true;
      } else {
        return false;
      }
    });
    // data.bu !== item.bu && data.department !== item.department && data.subDepartment !== item.subDepartment});
    setBuSecData(filterData);
  }
  const generateAddJSON = () => {
    let payload = {
      "indegeneEntity": selectedIndegeneEntity,
      "clientEntity": selectedClientEntity,
      "currency": selectedCurrency,
      "sowId": orderDashboardData.workOrder.selectedSOW.sowId,
      "sowName": orderDashboardData.workOrder.selectedSOW.sowName,
      "geographyCode": geographycode,
      "multiYearFlag": cofData.multiyearDealcheck === "Yes" ? true : false,
      "numberOfYears": cofData.multiyearDealcheck === "Yes" ? cofData.yearsofDeal : "",
      "fromDate": cofData.multiyearDealcheck === "Yes" ? cofData.startDate : orderDashboardData.workOrder.selectedSOW.sowStartDate,
      "toDate": cofData.multiyearDealcheck === "Yes" ? cofData.endDate : orderDashboardData.workOrder.selectedSOW.sowEndDate,
      "multiyearType" :cofData.multiyearDealcheck === "Yes"? cofData.datetype: "",
      "tcvAmount": totalcontractvalue,
      "financialSpocs": financialSpocdata(),
      "tcvAmountUsd": tcv_usd,
      "removedBu": [
      ],
      "addOrUpdateBuDepartments": buSecData,
      "invoiceScheduleAvailable": invoiceScheduleAvailable === "Yes",
      "invoiceSchedule": invoiceScheduleAvailable === "Yes" ? invoiceSchedule : null
    }
    return payload;
  }

  const generateUpdateJSON = () => {
    let payload = {
      "id": orderDashboardData.workOrderModal.selectedWorkOrder.id,
      "indegeneEntity": selectedIndegeneEntity,
      "clientEntity": selectedClientEntity,
      "currency": selectedCurrency,
      "sowId": orderDashboardData.workOrderModal.selectedWorkOrder.sowId,
      "sowName": orderDashboardData.workOrderModal.selectedWorkOrder.sowName,
      "geographyCode": geographycode,
      "multiYearFlag": multiyearDealcheck === "Yes" ? true : false,
      "numberOfYears": multiyearDealcheck === "Yes" ? yearsofDeal : "",
      "fromDate": orderDashboardData.workOrderModal.selectedWorkOrder.fromDate,
      "toDate":orderDashboardData.workOrder.selectedSOW.sowEndDate,
      "multiyearType" :multiyearDealcheck === "Yes"? datetype: "",
      "tcvAmount": totalcontractvalue,
      "tcvAmountUsd": tcv_usd,
      "financialSpocs": financialSpocdata(),
      "removedBu": getRemovedBu(),
      "parentId": orderDashboardData.workOrderModal.selectedWorkOrder.parentId || "",
      "addOrUpdateBuDepartments": buSecData,
      "invoiceScheduleAvailable": invoiceScheduleAvailable === "Yes",
      "invoiceSchedule": invoiceScheduleAvailable === "Yes" ? invoiceSchedule : null
    }
    return payload;
  }

  const handleSubmit = () => {
    let busecfilterData = buSecData.filter((data: any) => {
      return data.primaryClassCode === true;
    });
    // if(multiyearDealcheck === "Yes"  && (yearsofDeal === "" || datetype === "")){
    //   message.error("Please fill the required fields for Multi Year Deal");
    // }else 
    if(!buSectionEditable){
      message.error("One Combination of BU, Dept., Sub Dept. is in Edit Stage.");
      return;
    }
    if (invoiceScheduleAvailable === 'Yes') {
      const scheduleTotal = (invoiceSchedule?.installments || []).reduce((sum: any, item: any) => sum + (parseFloat(item.amount) || 0), 0);
      if (!invoiceSchedule || Math.abs(scheduleTotal - (parseFloat(totalcontractvalue) || 0)) > 0.01) {
        message.error("Sum of Invoice Schedule amounts should be equal to Total Contract Value.");
        return;
      }
    }
    if (busecfilterData.length === 0) {
      message.error("At least one BU combination should be marked as a Primary Class Code.");
      return;
    } else if (parseFloat(totalcontractvalue) !== parseFloat(tcvsumval)) {
      message.error("Sum of TCV Split should be equal to Total Contract Value.");
      return;
    }
    else if((totalcontractvalue === "" || totalcontractvalue === "0" || totalcontractvalue === "0.00")&& parentId !== ""){
      confirm({
        className: 'WorkOrderExistModal',
        title: < span>Please provide the reason and Netsuite Record ID</span>,
        content: <>
        <Spin spinning={orderDashboardData?.loading} size="large" >
            <span style={{ textAlign: 'justify', display: 'block' }
            }> As total contract value of the work order is marked zero, its mandatory to provide the netSuite record id  created against this workorder/parent id and a reason for the action you are taking.</span >
            {   <div>
                <div className='col-lg-4 col-md-4 col-sm-12'>
                    <FloatLabel label="Net-Suite Record ID*" value={netSuiteParentId }>
                    <Input
                      value={netSuiteParentId}
                      size='middle'
                      ref={ref_netSuiteParentId}
                      style={{ width: '100%', height: 58, marginRight: '10px', paddingTop: '15px' }}
                      // placeholder="SOW NAME"
                      disabled={true}
                      id="netSuiteParentId"
                      required={true}
                      // onChange={(e) =>{setNetSuiteParentId(e.target.value)}}
                    />
                  </FloatLabel>
                  </div>
                  <div style={{display:'flex',width:'600px',marginRight:'20px',textDecoration:'none'}} >
                  <FloatLabel label="Reason*" value={reason}>
                    <Input.TextArea
                      // value={reason}
                      ref={ref_reason}
                      size='middle'
                      rows={4}
                      style={{ width: '600px', marginRight: '10px',paddingTop:'20px', resize:'none',color:"black" }}
                      // placeholder="SOW NAME"
                      id="reason"
                      required={true}
                      // multiple={true}
                      
                      onChange={(e) => {debugger; setReason(e.target.value)}}
                    />
                  </FloatLabel>
                </div>
              </div>
            }
            <span style={{ textAlign: 'justify', display: 'block' }}>If you are sure that you want to proceed, click on Proceed with Updation. </span>
            </Spin>
        </>,
        okText: 'Proceed with Updation',
        width: 800,
        okType: 'danger',
        styles:{content: {
          borderRadius: '0',
          borderTop: '4px solid #1677ff',
          font: 'normal normal normal 14px/20px Nunito Sans',
          zIndex: 9998,
        },},
        cancelText: 'Cancel',
        onOk: (close) => {
          debugger;
          let temp_reason= ref_reason.current.resizableTextArea.textArea.value;
          let temp_netsuiteId = ref_netSuiteParentId.current.input.value;
          let payload:any =generateUpdateJSON();
          payload["reason"]=temp_reason;
          payload["netSuiteParentId"]=temp_netsuiteId;
          payload["proceed"]=true;
          if(temp_reason === "" || temp_netsuiteId === ""){
            rejectedApiMessage("Please provide the reason and Netsuite Record ID");
            return;
          }
          dispatch(addOrUpdateWorkOrder({ values: payload })).then((res: any) => {
            if (res.type === 'orderDashboard/addOrUpdateWorkOrder/fulfilled') {
              if (orderDashboardData.workOrderModal.type === "create") {
                notification.success({
                  message: 'Success',
                  description: 'Work Order Created Successfully'
                });
                close();
              }
              else {
                notification.success({ description: 'Work Order Updated Successfully', message: 'Success' });
                close();
              }
              dispatch(setWorkOrderModalIsOpen({ isModalOpen: false, type: "create", data: {} }));
              onSubmit();
            }
            else{
              rejectedApiMessage(res.payload)
            }
         });
        },
        onCancel: () => {
          // setReason("");
          // setNetSuiteParentId("");
        },
    });
    }
    else {
      let payload = orderDashboardData.workOrderModal.type === "create" ? generateAddJSON() : generateUpdateJSON();
      dispatch(addOrUpdateWorkOrder({ values: payload })).then((res: any) => {
        if (res.type === 'orderDashboard/addOrUpdateWorkOrder/fulfilled') {
          if (orderDashboardData.workOrderModal.type === "create") {
            notification.success({
              message: 'Success',
              description: 'Work Order Created Successfully'
            });
          }
          else {
            notification.success({ description: 'Work Order Updated Successfully', message: 'Success' });
          }
          dispatch(setWorkOrderModalIsOpen({ isModalOpen: false, type: "create", data: {} }));
          onSubmit();
        } else {
          if(res.payload.includes("SOW_ID_VALIDATION") && res.payload.includes("splitter")){
              let data = JSON.parse(res.payload.split("splitter")[1]);

            confirm({
              className: 'WorkOrderExistModal',
              title: < span>Are you sure you want to proceed?</span>,
              content: <>
                  <span style={{ textAlign: 'justify', display: 'block' }
                  }> A Work Order already exists with the same combination of Client Entity, Indegene Entity, Total Contract Value and Currency. You might be creating a duplicate Work Order.</span >
                  {
                      < Table
                          style={{ margin: '10px 0' }}
                          showHeader={true}
                          scroll={{ y: 240, x: 800}}
                          title={() => <span style={{
                              display: 'block',
                              textAlign: 'center',
                              fontWeight: '600',
                              // fontStyle: 'italic',
                          }}>Details of existing Work Orders</span>}
                          bordered columns={
                              [
                                  {
                                      title: 'SOW ID',
                                      dataIndex: 'sowId',
                                      key: 'sowId',
                                      width:150
                                  },
                                  {
                                    title: 'Work Order ID',
                                    dataIndex: 'id',
                                    key: 'id',
                                    width:150
                                  },
                                  {
                                    title: 'SOW Name',
                                    dataIndex: 'sowName',
                                    key: 'sowName',
                                    width:150
                                  },
                                  {
                                      title: 'Parent ID',
                                      dataIndex: 'parentId',
                                      key: 'parentId',
                                      width:150
                                  },
                                  {
                                      title: 'Client Entity',
                                      dataIndex: 'clientEntity',
                                      key: 'clientEntity',
                                      width:150
                                  },
                                  {
                                      title: 'Indegene Entity',
                                      dataIndex: 'indegeneEntity',
                                      key: 'indegeneEntity',
                                      width:150
                                  },
                                  {
                                      title: 'Total Contract Value',
                                      dataIndex: 'tcvAmount',
                                      key: 'tcvAmount',
                                      width:150
                                  },
                                  {
                                      title: 'Base Currency',
                                      dataIndex: 'currency',
                                      key: 'currency',
                                      width:150
                                  },
                              ]} dataSource={data || []} pagination={false} />
                  }
                  <span style={{ textAlign: 'justify', display: 'block' }}>If you are sure that you want to proceed, click on Proceed with Creation. </span>
  
              </>,
              okText: 'Proceed with Creation',
              width: 800,
              okType: 'danger',
              styles:{content: {
                borderRadius: '0',
                borderTop: '4px solid #1677ff',
                font: 'normal normal normal 14px/20px Nunito Sans',
                zIndex: 9998,
              },},
              cancelText: 'Cancel',
              onOk: () => {
                let temp :any= payload;
                temp["proceed"]=true;
                dispatch(addOrUpdateWorkOrder({ values: temp })).then((res: any) => {
                  if (res.type === 'orderDashboard/addOrUpdateWorkOrder/fulfilled') {
                    if (orderDashboardData.workOrderModal.type === "create") {
                      notification.success({
                        message: 'Success',
                        description: 'Work Order Created Successfully'
                      });
                    }
                    else {
                      notification.success({ description: 'Work Order Updated Successfully', message: 'Success' });
                    }
                    dispatch(setWorkOrderModalIsOpen({ isModalOpen: false, type: "create", data: {} }));
                    onSubmit();
                  }
                  else{
                    rejectedApiMessage(res.payload)
                  }
               });
              },
              onCancel: () => {
  
              },
          });
            
          //  if( window.confirm(res.payload.split("VALIDATION")[1])){
          //   let temp :any= payload;
          //   temp["proceed"]=true;
          //   dispatch(addOrUpdateWorkOrder({ values: temp })).then((res: any) => {
          //     if (res.type === 'orderDashboard/addOrUpdateWorkOrder/fulfilled') {
          //       if (orderDashboardData.workOrderModal.type === "create") {
          //         notification.success({
          //           message: 'Success',
          //           description: 'Work Order Created Successfully'
          //         });
          //       }
          //       else {
          //         notification.success({ description: 'Work Order Updated Successfully', message: 'Success' });
          //       }
          //       dispatch(setWorkOrderModalIsOpen({ isModalOpen: false, type: "create", data: {} }));
          //       onSubmit();
          //     }
          //     else{
          //       rejectedApiMessage(res.payload)
          //     }
          //  });
          // }
          
        }
        else{
          rejectedApiMessage(res.payload);
        }
          // rejectedApiMessage(res.payload);
        }
      });
    }

  };
  const getRemovedBu = () => {
    let removedBu: any = [];
    if (orderDashboardData.workOrderModal.type === "edit") {
      orderDashboardData.workOrderModal.selectedWorkOrder.workOrderBuDepartments.forEach((data: any) => {
        let count = buSecData.filter((buData: any) => data.id === buData.id);
        if (count.length === 0) {
          removedBu.push(data.id);
        }
      });
    }
    return removedBu;
  }
  useEffect(() => {
    if (orderDashboardData.workOrderModal.isModalOpen) {
      setSowId(orderDashboardData.workOrder.selectedSOW.sowId);
      setSowName(orderDashboardData.workOrder.selectedSOW.sowName);
      dispatch(fetchClientIndegeneCurrency()).then((response: any) => {
        if (response.type !== 'orderDashboard/clientIndegeneEntityDetails/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else {
          setClientEntityDataList(response.payload);
          setClientEntityList(Object.keys(response.payload.clientEntityIndegeneEntity));
          // setSowIdList(response.payload.sowIdList);
        }
      });

      dispatch(fetchBuDepartmentSubDepartment()).then((response: any) => {
        if (response.type !== 'orderDashboard/fetchBuDepartmentSubDepartment/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else {
          setBuDatalist(response.payload);
          setBulist(Object.keys(response.payload));
        }
      });

      dispatch(fetchFinanacialSpoc({ roleNameval: 'Finance' })).then((response: any) => {
        if (response.type !== 'orderDashboard/fetchFinanacialSpoc/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else {
          setFinancialspoclist(response.payload);
          const roleanduserfinance = JSON.parse(localStorage.getItem('myorders_user_access_data')!);
          if (orderDashboardData.workOrderModal.type === "create") {
            if (roleanduserfinance != null) {
              let checkdata: any[] = Object.keys(roleanduserfinance.roleAccessMap);
              if (checkdata.includes('Finance')) {
                let financedata: any[] = []
                response.payload.filter((itemdata: any) => {
                  if (itemdata.email === roleanduserfinance.employeeDetailsDTO.email) {
                    financedata.push({ 'label': itemdata.name, 'value': itemdata.email });
                    setFinancialspoc(financedata)
                  }
                });
              }
            }

          }


          // if(roleanduserfinance)
        }
      });


    }
    else {
      setCOFData({});
      setSelectedClientEntity("");
      setIndegeneEntityList([]);
      setSelectedIndegeneEntity("");
      setSelectedCurrency("");
      setCurrencyList([]);
      setSelectedBuData("");
      setBulist([]);
      setSelectedDepartment("");
      setDepartmentList([]);
      setSelectedSubDepartment("");
      setSubDepartmentList([]);
      setTcvSplit("");
      setBuSecData([]);
      setBuSecID("");
      setClientEntityDataList([]);
      setClientEntityList([]);
      setBuDatalist([]);
      setFinancialspoclist([]);
      setFinancialspoc([]);
      setGeographycode("");
      setClassCode("");
      setPrimaryclasscode(false);
      setSowId("");
      setSowName("");
      setTotalcontractvalue("");
      setBurelatedfields(true);
      setSubDepartmentFiled(true);
      setCliententityrelatedfields(true);
      setConfirmeditsection(false);
      setIsCustomDateRange(false);
      setDatetype("");
      setParentId("");
      setNoOfYearsOptions([]);
      setYearsofDeal("");
      setBuSectionEditable(true);
      setTcv_usd("");
      setInvoiceScheduleAvailable("No");
      setInvoiceSchedule(null);
      setShowInvoiceScheduleModal(false);
    }

  }, [orderDashboardData.workOrderModal.isModalOpen]);

  useEffect(() => {
    if (orderDashboardData.workOrderModal.type === "create") {
      if (Object.keys(confirmPopUpData).length > 0) {
        setCOFData(confirmPopUpData);
      } else {
        setCOFData({
          multiyearDealcheck: 'No',
        })
      }
    }

  }, [confirmPopUpData])

  useEffect(() => {

    if(orderDashboardData.workOrderModal.type === "edit" && orderDashboardData.workOrderModal.selectedWorkOrder.multiYearFlag ){
      let multiyearType = orderDashboardData.workOrderModal.selectedWorkOrder.multiyearType;
      let dataType ="";
      if(multiyearType === "Fiscal Year"){
        dataType ="fiscal";
      }else if(multiyearType === "Calender Year"){
        dataType ="calender";
      }else{
        dataType ="custom";
      }
      dispatch(getMultiYearDealDates({values:{ multiyearType: dataType, sowStartDate: orderDashboardData.workOrderModal.selectedWorkOrder.sowStartDate, sowEndDate: orderDashboardData.workOrderModal.selectedWorkOrder.sowEndDate, fromDate: moment(orderDashboardData.workOrderModal.selectedWorkOrder.fromDate).format(dateFormat), toDate: moment(orderDashboardData.workOrderModal.selectedWorkOrder.toDate).format(dateFormat) }})).then((response: any) => {
        if (response.type === 'orderDashboard/getMultiYearDealDates/fulfilled') {
            // setParentIdDateOptions( response.payload.multiYearResponse ||[]);
            let options =[];
            for(let i=2;i<=response.payload.totalResult;i++){
              options.push({label:i,value:i});
            }
            setNoOfYearsOptions(options);
        }
        else{
          rejectedApiMessage(response.payload);
        }
      });
      // getNumberOfyearOptions(dataType,orderDashboardData.workOrderModal.selectedWorkOrder.fromDate,orderDashboardData.workOrderModal.selectedWorkOrder.toDate);
  }

  },[orderDashboardData.workOrderModal.type]);

  useEffect(() => {
  }, [noOfYearsOptions]);

  useEffect(() => {

    if(buSecData.length === 0){
      setPrimaryclasscode(true);
    }
  }, [buSecData]);

  useEffect(() => {
    setInvoiceSchedule((prev: any) => {
      if (!prev) return prev;
      const tcv = parseFloat(totalcontractvalue) || 0;
      const installments = prev.installments || [];
      const isPastDated = (item: any) => item.invoiceDate && moment(item.invoiceDate).isBefore(moment(), 'day');

      // split a total proportionally across the given weights, putting any rounding remainder on the last entry
      const distributeProportionally = (total: number, weights: number[]) => {
        if (weights.length === 0) return [];
        const sumWeights = weights.reduce((s, w) => s + w, 0);
        const effectiveWeights = sumWeights > 0 ? weights : weights.map(() => 1);
        const effectiveSum = effectiveWeights.reduce((s, w) => s + w, 0);
        const values = effectiveWeights.map((w) => parseFloat(((w / effectiveSum) * total).toFixed(2)));
        const roundedSum = values.reduce((s, v) => s + v, 0);
        values[values.length - 1] = parseFloat((values[values.length - 1] + (total - roundedSum)).toFixed(2));
        return values;
      };

      const pastItems = installments.filter(isPastDated);
      const futureItems = installments.filter((item: any) => !isPastDated(item));

      // past invoices already raised: amount is frozen; refresh the percentage it represents when percentage is used
      const pastAmounts = pastItems.map((item: any) => parseFloat(item.amount) || 0);
      const sumPastAmount = pastAmounts.reduce((s: number, a: number) => s + a, 0);
      const pastPercentages = pastAmounts.map((amount: number) => (prev.percentageAvailable && tcv > 0 ? parseFloat(((amount / tcv) * 100).toFixed(2)) : undefined));
      const sumPastPercentage = pastPercentages.reduce((s: number, p: number) => s + (p || 0), 0);

      // future invoices: redistribute the remaining contract value proportionally when percentage-based, or equally otherwise
      const remainingAmount = parseFloat((tcv - sumPastAmount).toFixed(2));
      const remainingPercentage = parseFloat((100 - sumPastPercentage).toFixed(2));
      const futureWeights = prev.percentageAvailable ? futureItems.map((item: any) => parseFloat(item.percentage) || 0) : futureItems.map(() => 1);
      const futureAmounts = distributeProportionally(remainingAmount, futureWeights);
      const futurePercentages = prev.percentageAvailable ? distributeProportionally(remainingPercentage, futureWeights) : futureItems.map(() => undefined);

      let pastIdx = 0;
      let futureIdx = 0;
      const updatedInstallments = installments.map((item: any) => {
        if (isPastDated(item)) {
          const updated = { ...item, amount: pastAmounts[pastIdx], percentage: pastPercentages[pastIdx] };
          pastIdx++;
          return updated;
        }
        const updated = { ...item, amount: futureAmounts[futureIdx], percentage: futurePercentages[futureIdx] };
        futureIdx++;
        return updated;
      });

      const totalAllocatedAmount = updatedInstallments.reduce((sum: any, item: any) => sum + (parseFloat(item.amount) || 0), 0);
      return { ...prev, totalContractValue: tcv, installments: updatedInstallments, totalAllocatedAmount };
    });
  }, [totalcontractvalue]);


  useEffect(() => {

    if (orderDashboardData.workOrderModal.type === "edit" && Object.keys(clientEntityDataList).length > 0) {
      if (Object.keys(orderDashboardData.workOrderModal.selectedWorkOrder).length > 0) {
        setCOFData({
          multiyearDealcheck: orderDashboardData.workOrderModal.selectedWorkOrder.multiYearFlag ? "Yes" : "No",
          yearsofDeal: orderDashboardData.workOrderModal.selectedWorkOrder.numberOfYears,
          startDate: orderDashboardData.workOrderModal.selectedWorkOrder.fromDate,
          endDate: orderDashboardData.workOrderModal.selectedWorkOrder.toDate,
        })
        setMultiyearDealcheck(orderDashboardData.workOrderModal.selectedWorkOrder.multiYearFlag ? "Yes" : "No");
        setYearsofDeal(orderDashboardData.workOrderModal.selectedWorkOrder.numberOfYears);
        setDatetype(orderDashboardData.workOrderModal.selectedWorkOrder.multiyearType||"");
        setSelectedClientEntity(orderDashboardData.workOrderModal.selectedWorkOrder.clientEntity);
        setTcv_usd(orderDashboardData.workOrderModal.selectedWorkOrder.tcvAmountUsd);
        setStartDate(orderDashboardData.workOrderModal.selectedWorkOrder.fromDate);
        setEndDate(orderDashboardData.workOrderModal.selectedWorkOrder.toDate);
        setIndegeneEntityList(clientEntityDataList.clientEntityIndegeneEntity[orderDashboardData.workOrderModal.selectedWorkOrder.clientEntity]);
        setSelectedIndegeneEntity(orderDashboardData.workOrderModal.selectedWorkOrder.indegeneEntity);
        setCurrencyList(clientEntityDataList.clientEntityCurreny[orderDashboardData.workOrderModal.selectedWorkOrder.clientEntity]);
        setSelectedCurrency(orderDashboardData.workOrderModal.selectedWorkOrder.currency);
        setGeographycode(orderDashboardData.workOrderModal.selectedWorkOrder.geographyCode);
        setTotalcontractvalue(orderDashboardData.workOrderModal.selectedWorkOrder.tcvAmount);
        // setFinancialspoclist(orderDashboardData.workOrderModal.selectedWorkOrder.financialSpocs);
        setFinancialspoc(getFinanaicalSpocName(orderDashboardData.workOrderModal.selectedWorkOrder.financialSpocs));
        setBuSecData(orderDashboardData.workOrderModal.selectedWorkOrder.workOrderBuDepartments);
        setParentId(orderDashboardData.workOrderModal.selectedWorkOrder.parentId);
        setSowId(orderDashboardData.workOrderModal.selectedWorkOrder.sowId);
        setSowName(orderDashboardData.workOrderModal.selectedWorkOrder.sowName);
        debugger;
        setNetSuiteParentId(orderDashboardData.workOrderModal.selectedWorkOrder.netSuiteParentId);
        setInvoiceScheduleAvailable(orderDashboardData.workOrderModal.selectedWorkOrder.invoiceScheduleAvailable ? "Yes" : "No");
        setInvoiceSchedule(orderDashboardData.workOrderModal.selectedWorkOrder.invoiceSchedule || null);

        setPrimaryclasscode(false);
        
      }
    }
  }, [clientEntityDataList, orderDashboardData.workOrderModal.type]);

  useEffect(() => {

  },[reason, netSuiteParentId])

  // Add BU Section function starts
  const getNumberOfyearOptions = (dateType: any,fromDate:any, toDate: any) => {
    dispatch(getMultiYearDealDates({values:{ multiyearType: dateType, sowStartDate: orderDashboardData.workOrderModal.selectedWorkOrder.sowStartDate, sowEndDate: orderDashboardData.workOrderModal.selectedWorkOrder.sowEndDate, fromDate: moment(fromDate).format(dateFormat), toDate: moment(toDate).format(dateFormat) }})).then((response: any) => {
      if (response.type === 'orderDashboard/getMultiYearDealDates/fulfilled') {
          // setParentIdDateOptions( response.payload.multiYearResponse ||[]);
          let options =[];
          for(let i=2;i<=response.payload.totalResult;i++){
            options.push({label:i,value:i});
          }
          setNoOfYearsOptions(options);
      }
      else{
        rejectedApiMessage(response.payload);
      }
    });
  }
  const findBuSecDataRow = (buSecData: any) => {
    let count = buSecData.filter((data: any) => {
      if (data.bu === selectedBuData && data.department === selectedDepartment && data.subDepartment === selectedSubDepartment) {
        return true;
      }
    });
    if (count.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }
  const getFiscalYearTimestamps = () => {
    const startMonthName = "April";
    const endMonthName = "March";
    const quarter = moment().quarter();
    if (quarter == 1) {
      return {
        current: {
          start: moment().subtract(1, 'year').month(startMonthName).startOf('month'),
          end: moment().month(endMonthName).endOf('month')
        }
      };
    } else {
      return {
        current: {
          start: moment().month(startMonthName).startOf('month'),
          end: moment().add(1, 'year').month(endMonthName).endOf('month')
        }
      };
    }
  };
  const tcvsumval = buSecData.reduce((resob: any, object: any) => {
    return (parseFloat(resob) + parseFloat(object.tcvSplit)).toFixed(2);
  }, 0.00);

  const addBuData = () => {
    if (findBuSecDataRow(buSecData)) {
      message.error("Combination of BU, Department and Sub-Department already added. Please edit the existing row or delete the existing row and add new row");
      return;
    }
    if(orderDashboardData.workOrderModal.type==="create"&&(tcvSplit==0 || tcvSplit=="" || tcvSplit<0)){
      message.error("TCV Split should be greater than 0");
      return;

    }

    let datatemp: any = {
      bu: selectedBuData,
      department: selectedDepartment,
      subDepartment: selectedSubDepartment,
      tcvSplit: tcvSplit,
      classCode: classCode,
      primaryClassCode: primaryclasscode
    }

    if (datatemp.tcvSplit === "") {
      datatemp.tcvSplit = 0;
    } else {
      datatemp.tcvSplit = parseFloat(datatemp.tcvSplit).toFixed(2);
    }

    if ((parseFloat(tcvsumval) + parseFloat(datatemp.tcvSplit)) > parseFloat(totalcontractvalue)) {
      message.error("The sum of the TCV Split cannot be greater than the Total Contract Value.");
      return;
    }


    if (buSecID) {
      datatemp['id'] = buSecID;
    }
    let tempDatatrue = buSecData.filter((data: any) => data.primaryClassCode === true);
    let tempDatafalse = buSecData.filter((data: any) => data.primaryClassCode === false);
    if (datatemp.primaryClassCode === true) {
      let _temp: any[] = [];
      tempDatatrue.map((data: any) => {
        let _data = JSON.parse(JSON.stringify(data));
        _data['primaryClassCode'] = false;
        _temp.push(_data);
      });
      tempDatatrue = _temp;
    }
    setBuSecData([...tempDatatrue, ...tempDatafalse, datatemp]);
    setSelectedBuData("");
    setBulist(Object.keys(buDatalist));
    setSelectedDepartment("");
    setDepartmentList([]);
    setSelectedSubDepartment("");
    setSubDepartmentList([]);
    setTcvSplit("");
    setBuSecID("");
    setClassCode("");
    setPrimaryclasscode(false);
    setBuSectionEditable(true);
    setBurelatedfields(true);
    setSubDepartmentFiled(true);
    // setConfirmeditsection(false);
    // setEditConfirmPopup(false);
    // setIsCustomDateRange(false);
    // setDatetype("");
    // setYearsofDeal("");
  }
  // Add BU Section function ends
  // Handle change function starts
  const handleChangedValue = (id: any, value: any) => {
    selectRef.current.blur();
    if (id === 'clientEntity') {
      setSelectedClientEntity(value);
      setIndegeneEntityList(clientEntityDataList.clientEntityIndegeneEntity[value] || []);
      setCurrencyList(clientEntityDataList.clientEntityCurreny[value]||[]);
      // setIndegeneEntityList(Object.keys(clientEntityDataList[value].clientEntityIndegeneEntity[value]));
      setSelectedIndegeneEntity("");
      setSelectedCurrency("");
      setTotalcontractvalue("");
      setTcv_usd("");
      setCliententityrelatedfields(false);
      let encodeClientEntity = encodeURIComponent(value);
      dispatch(fetchGeographyCode({ clientEntity: encodeClientEntity })).then((response: any) => {
        if (response.type !== 'orderDashboard/fetchGeographyCode/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else {
          if(response.payload){
            setGeographycode(response.payload.geographyCode.geographyCd);
          }
          else{
            rejectedApiMessage("Geography Code not found for the selected Client Entity");
            setGeographycode("");
          }
          // setSowIdList(response.payload.sowIdList);
        }
      });

    }
    if (id === 'indegeneEntity') {
      setSelectedIndegeneEntity(value);
    }
    if (id === 'currency') {
      setSelectedCurrency(value);
      setTotalcontractvalue("");
      setTcv_usd("");
    }

    if (id === 'bu') {
      setSelectedBuData(value);
      setDepartmentList(Object.keys(buDatalist[value]));
      setBurelatedfields(false);
      setSubDepartmentFiled(true);
      setSubDepartmentList([]);
      setSelectedDepartment("");
      setSelectedSubDepartment("");
    }
    if (id === 'department') {
      setSelectedDepartment(value);
      setSubDepartmentFiled(false);
      setSubDepartmentList(buDatalist[selectedBuData][value]);
      setSelectedSubDepartment("");
    }
    if (id === 'subDepartment') {
      setSelectedSubDepartment(value);
      dispatch(fetchClassCodes({ buName: selectedBuData, deptName: encodeURIComponent(selectedDepartment), subDeptName: encodeURIComponent(value) })).then((response: any) => {
        if (response.type !== 'orderDashboard/fetchClasscode/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else {
          setClassCode(response.payload?.classCode);
          // setSowIdList(response.payload.sowIdList);
        }
      });
    }

    if (id === 'tcvSplit') {
      
      setTcvSplit(value);
    }

    if (id === 'financialSpoc') {
      setFinancialspoc(value);
    }

    if (id === 'totalcontractvalue') {

      setTotalcontractvalue(value);
    }
    if (id === 'invoiceScheduleAvailable') {
      if (value === 'No' && invoiceScheduleAvailable === 'Yes' && (invoiceSchedule?.installments || []).some((item: any) => item.locked || dayjs(item.invoiceDate).isBefore(dayjs(), 'day'))) {
        // past invoices already raised against this schedule would be lost if the schedule is removed
        message.error('This Work Order has invoice(s) with a past date and cannot be changed.');
        return;
      }
      setInvoiceScheduleAvailable(value);
      if (value === 'No') {
        setInvoiceSchedule(null);
      }
    }
    if (id === 'yearsofDeal') {
      setYearsofDeal(value);
    }
    if (id === 'multiyearDealcheck') {
      if (value === 'Yes') {
        setMultiyearDealcheck('Yes');
        setvisibleField(true);
        setYearsofDeal('');
        setDatetype('');
      }
      else {
        setMultiyearDealcheck('No');
        setvisibleField(false);
        setIsCustomDateRange(false);
        setYearsofDeal('');
        setDatetype('');
        setStartDate(orderDashboardData.workOrder.selectedSOW.sowStartDate || startDate);
        setEndDate(orderDashboardData.workOrder.selectedSOW.sowEndDate || endDate);
      }
      setIsCustomDateRange(false);
    }
    if (id === 'datetype') {
      if (value === 'Fiscal Year') {
        const dates = getFiscalYearTimestamps();
        setDatetype('Fiscal Year');
        setStartDate(moment(dates.current.start).format('YYYY-MM-DD'));
        setEndDate(moment(dates.current.end).format('YYYY-MM-DD'));
        setIsCustomRangeDisabled(true);
        setIsCustomDateRange(false);
      } else if (value === 'Calender Year') {
        const startOfYear = moment().startOf('year');
        const endOfYear = moment().endOf('year');

        const calendarYearStartDate = startOfYear.format('YYYY-MM-DD');
        const calendarYearEndDate = endOfYear.format('YYYY-MM-DD');
        setDatetype('Calender Year');
        setStartDate(calendarYearStartDate);
        setEndDate(calendarYearEndDate);
        setIsCustomRangeDisabled(true);
        setIsCustomDateRange(false);
      }
      else {
        setDatetype('Custom Range');
        setIsCustomRangeDisabled(false);
        setIsCustomDateRange(true);
      }
    }
    if (id === 'customDateSelection') {
      setStartDate(value[0]);
      setEndDate(value[1]);
    }
    if(id === 'netSuiteParentId'){
      setNetSuiteParentId(value);
    }
    if(id === 'reason'){
      setReason(value);
    }

  }

  const financialSpocdata = () => {
    let financedata: any[] = [];
    financialspoc.map((data: any) => {
      let tempData = orderDashboardData?.workOrderModal?.selectedWorkOrder?.financialSpocs || [];
      let _metadata = tempData.filter((data1: any) => data1.email === data.value);
      financedata.push({ name: data.label, email: data.value, id: _metadata.length > 0 ? _metadata[0].id : null })
    });
    return financedata;
  }

  const scheduleDescriptionLabel = (scheduleDescription: any) => {
    if (scheduleDescription === 'MONTHLY') return 'Monthly';
    if (scheduleDescription === 'MILESTONE') return 'Milestone';
    if (scheduleDescription === 'CUSTOM') return 'Custom';
    return '';
  }

  const handleInvoiceScheduleSave = (schedule: any) => {
    setInvoiceSchedule(schedule);
    setShowInvoiceScheduleModal(false);
  }

  const getFinanaicalSpocName = (item: any[]) => {
    let financedata: any[] = [];
    item.map((data: any) => {
      financedata.push({ 'label': data.name, 'value': data.email })
    });
    return financedata;
  }


  const isAddbuttonEnabled = () => {
    if (selectedBuData && selectedDepartment && selectedSubDepartment && classCode && tcvSplit) {
      return true;
    } else {
      return false;
    }
  }

  const handleCurrencyChange = (value: any) => {
      dispatch(getCovertedCurrency({
        'bookingMonth': selectedSOW.sowCreatedDate,
        'quoteCurrency': "USD",
        'baseCurrency':selectedCurrency ,
        'num': value,
      })).then((response: any) => {
        if (response.type !== 'orderDashboard/getCovertedCurrency/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else {
          setTcv_usd(response.payload.value);
          // setSowIdList(response.payload.sowIdList);
        }
      }); 
  }

  const inputElem = useRef();
  const handleKeyDown = (e: any) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
      e.preventDefault();
    }
  };
  const handlekeyDown_TCV = (e: any) => {
    //enable ctr + c and ctr + v
    if(e.ctrlKey && (e.key === "c" || e.key === "v")){
      return;
    }
    if(totalcontractvalue.toString().includes(".") && totalcontractvalue.toString().split(".")[1].length >= 2 && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab"){
      e.preventDefault();
    }
    if (!(e.key === "0" || e.key === "1" || e.key === "2" || e.key === "3" || e.key === "4" || e.key === "5" || e.key === "6" || e.key === "7" || e.key === "8" || e.key === "9" || e.key === "." || e.key === "Backspace" || e.key === "Delete" || e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "Tab")) {
      e.preventDefault();
    }
  }
  const handlekeyDown_TCVSplit = (e: any) => {
    if(e.ctrlKey && (e.key === "c" || e.key === "v")){
      return;
    }
    if(tcvSplit.toString().includes(".") && tcvSplit.toString().split(".")[1].length >= 2 && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab"){
      e.preventDefault();
    }
    if (!(e.key === "0" || e.key === "1" || e.key === "2" || e.key === "3" || e.key === "4" || e.key === "5" || e.key === "6" || e.key === "7" || e.key === "8" || e.key === "9" || e.key === "." || e.key === "Backspace" || e.key === "Delete" || e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "Tab")) {
      e.preventDefault();
    }
  }
  const get2decimalvalueNumber = (value: any) => {
    if (value === "") {
      return value;
    } else {
      return parseFloat(value).toFixed(2);
    }
  }
  // Handle change function ends
  return (
    <Spin spinning={orderDashboardData?.loading || buDatalist.length==0} tip="Loading...">
    <div style={{ margin: '15px', padding: '15px' }}>

      {/* <form onSubmit={handleSubmit} className="form-component" style={{ maxWidth: '100%' }}> */}
      <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <FloatLabel label="SOW ID *" value={sowId}>
            {/* <InputTextBox
                label="SOW ID"
                value={sowId}
                placeholder="SOW ID"
                id="sowId"
                required={true}
                disabled={true}
                onChange={(_id, sowIdVal,currentValue)=>handleChangedValue(_id,sowIdVal)}
              /> */}
            <Input
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', color: '#00000080', paddingTop: '15px' }}
              value={sowId}
              // placeholder="SOW ID"
              id="sowId"
              required={true}
              disabled={true}
              onChange={(e) => handleChangedValue('sowId', e.target.value)}
            />
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <FloatLabel label="SOW Name *" value={sowName}>
            <Input
              value={sowName}
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', color: '#00000080', paddingTop: '15px' }}
              // placeholder="SOW NAME"
              id="sowName"
              required={true}
              disabled={true}
              onChange={(e) => handleChangedValue('sowName', e.target.value)}
            />
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Client Entity *" value={selectedClientEntity}>
            <Select
              showSearch
              allowClear={false}
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              // placeholder="Select Client Entity"
              optionFilterProp="children"
              value={selectedClientEntity}
              onSelect={(value: string) => handleChangedValue('clientEntity', value)}
              disabled={orderDashboardData.workOrderModal.type !== "create"}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...clientEntityList].sort((a: any, b: any) => a.localeCompare(b)).map((item: any) => ({ value: item }))}
            >
            </Select>
          </FloatLabel>
        </div>
      </div>
      <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Indegene Entity *" value={selectedIndegeneEntity}>
            <Select
              showSearch
              allowClear={false}
              ref={selectRef}
              size='middle'
              // style={{ width: 200 }}
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              // placeholder="Select Indegene Entity"
              optionFilterProp="children"
              value={selectedIndegeneEntity}
              onSelect={(value: string) => handleChangedValue('indegeneEntity', value)}
              disabled={cliententityrelatedfields}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...indegeneEntityList].sort((a: any, b: any) => a.localeCompare(b)).map((item: any) => ({ value: item }))}
            >
            </Select>
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Currency *" value={selectedCurrency}>
            <Select
              showSearch
              allowClear={false}
              ref={selectRef}
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              // placeholder="Select Currency"
              optionFilterProp="children"
              value={selectedCurrency}
              onSelect={(value: string) => handleChangedValue('currency', value)}
              disabled={cliententityrelatedfields}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...currencyList].sort((a: any, b: any) => a.localeCompare(b)).map((item: any) => ({ value: item }))}
            >
            </Select>
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <FloatLabel label="Total Contract Value *" value={totalcontractvalue}>
            <Input
              type='text'
              min={0}
              step={0.01}
              onKeyDown={handlekeyDown_TCV}
              // onWheel={(e) => {
              //   const target = e.target as HTMLInputElement;
              //   target.blur()
              // }}
              value={totalcontractvalue}
              id="totalcontractvalue"
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', paddingTop: '15px' }}
              required={true}
              disabled={selectedCurrency === "" ? true : false}
              onChange={(e) => {                
                handleChangedValue('totalcontractvalue', e.target.value)}}

              onBlur={(e) => {
                setTotalcontractvalue(get2decimalvalueNumber(e.target.value));
                handleCurrencyChange( get2decimalvalueNumber(e.target.value));
              }  }
            />
          </FloatLabel>
        </div>
      </div>
      <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <FloatLabel label="Geography Code *" value={geographycode}>
            {/* <InputTextBox
                label="Geography Code"
                value={geographycode}
                placeholder="Geography Code"
                id="geographyCode"
                required={true}
                disabled={true}
                onChange={(_id, geographyCodeVal,currentValue)=>handleChangedValue(_id,geographyCodeVal)}
              /> */}
            <Input
              value={geographycode}
              id="geographycode"
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', color: '#00000080', paddingTop: '15px' }}
              required={true}
              disabled={true}
              onChange={(e) => handleChangedValue('geographycode', e.target.value)}
            />
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Finance SPOC *" isMultiSelect={true} value={financialspoc.map((item: any) => item.name)}>
            <Select
              autoClearSearchValue
              mode="multiple"
              size='middle'
              ref={selectRef}
              className='financialspoc-select'
              style={{ width: '100%', marginRight: '10px',maxHeight:'100px', minHeight:'58px' }}
              optionFilterProp="children"
              value={financialspoc.map((item: any) => item)}
              // onSelect={(value: string | string[]) => handleChangedValue('financialSpoc', value)}
              onChange={(value: string | string[]) => { handleChangedValue('financialSpoc', value) }}
              labelInValue
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...financialspoclist].sort((a: any, b: any) => a.name.localeCompare(b.name)).map((item: any) => ({ value: item.email, label: item.name }))}
            >
            </Select>
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Invoice Schedule Available *" value={invoiceScheduleAvailable}>
            <Select
              allowClear={false}
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              value={invoiceScheduleAvailable}
              onSelect={(value: string) => handleChangedValue('invoiceScheduleAvailable', value)}
              options={invoiceScheduleAvailableOptions}
            >
            </Select>
          </FloatLabel>
        </div>
      </div>

      <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12' style={{display:'flex'}}>
          <div style={{width:'90%'}}>
          <FloatLabel label="Parent ID" value={parentId}>
            {/* <InputTextBox
                label="SOW ID"
                value={sowId}
                placeholder="SOW ID"
                id="sowId"
                required={true}
                disabled={true}
                onChange={(_id, sowIdVal,currentValue)=>handleChangedValue(_id,sowIdVal)}
              /> */}
            <Input
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', color: '#00000080', paddingTop: '15px' }}
              value={parentId}
              // placeholder="SOW ID"
              id="sowId"
              required={false}
              disabled={true}
              onChange={(e) => handleChangedValue('parentId', e.target.value)}
            />
          </FloatLabel>
          </div>
            <div style={{margin:'auto', paddingBottom:'18px'}}>
              <Tooltip title={
                <>
                <p>
                From 25th of the Current Month till 5th of Next Month Parent ID is triggered through Work Order Creation. Opportunity Linking is not Mandatory
                </p>
                <p>
                From 6th to 24th of the Current Month Parent ID will be generated once a Work Order is Created and Opportunity is linked.
                </p>
                </>
              }>
              <span><InfoCircleOutlined style={{color:'#034EA2'}} /></span>
            </Tooltip>
            </div>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12'>
        <FloatLabel label="Total Contract Value (USD)" value={tcv_usd}>

            <Input
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', color: '#00000080', paddingTop: '15px' }}
              value={tcv_usd}
              id="tsc_usd"
              required={true}
              disabled={true}
              // onChange={(e) => handleChangedValue('tcv_usd', e.target.value)}
            />
          </FloatLabel>
        </div>
      </div>

      <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ width: 'calc(100% - 20px)', margin: '10px' }}>
          {invoiceScheduleAvailable === 'Yes' && !invoiceSchedule && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eef4fb', border: '1px solid #cfe0f2', borderRadius: '4px', padding: '12px 16px' }}>
              <span>Invoice schedule is required for this work order.</span>
              <Button label="ADD SCHEDULE" type="submit" onClick={() => setShowInvoiceScheduleModal(true)} />
            </div>
          )}
          {invoiceScheduleAvailable === 'Yes' && invoiceSchedule && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eef4fb', border: '1px solid #cfe0f2', borderRadius: '4px', padding: '12px 16px' }}>
                <span>{scheduleDescriptionLabel(invoiceSchedule.scheduleDescription)} schedule — {invoiceSchedule.installments?.length || 0} invoice lines</span>
                <Button label="EDIT SCHEDULE" type="submit" onClick={() => setShowInvoiceScheduleModal(true)} />
              </div>
              <Table
                style={{ marginTop: '10px' }}
                className='table-style'
                pagination={false}
                dataSource={invoiceSchedule.installments || []}
                rowKey={(record: any, index?: number) => `${record.description}-${index}`}
                columns={[
                  { title: 'Type', key: 'type', render: () => scheduleDescriptionLabel(invoiceSchedule.scheduleDescription) },
                  { title: 'Description', dataIndex: 'description', key: 'description' },
                  { title: 'Invoice Date', dataIndex: 'invoiceDate', key: 'invoiceDate', render: (value: any) => value ? moment(value).format('YYYY-MM-DD') : '—' },
                  ...(invoiceSchedule.percentageAvailable ? [{ title: 'Percentage (%)', dataIndex: 'percentage', key: 'percentage', render: (value: any) => value ?? '—' }] : []),
                  { title: `Amount (${selectedCurrency || 'USD'})`, dataIndex: 'amount', key: 'amount', render: (value: any) => value ?? '—' },
                ]}
              />
            </>
          )}
        </div>
      </div>

      <div style={orderDashboardData.workOrderModal.type === "create" ? { display: 'none' } : { display: 'none' }} className="row">
        <div>
          <span className ='maplink' >Show multi year deal section ?</span> <Switch checked={confirmeditsection} onChange={onChange} />
        </div>

        <div style={confirmeditsection === false ? { display: 'none' } : { display: 'block' }}>
          {/* <div style={{ display: 'flex', justifyContent: 'center', width: 'calc(100% - 20px)', backgroundColor: "#f5f8fa", padding: '10px 0px 10px 0px', color: '#000', margin: '10px' }}>
            <div style={{ font: 'bold 14px / 20px "Nunito Sans"' }}>Multi Year Deal Section</div>&nbsp;

          </div> */}
          <Divider orientation='center'>Multi Year Deal Section</Divider>
          <div className='row'>
            <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
              <FloatLabel label="Is It a Multi Year Deal ? *" value={multiyearDealcheck}>
                <Select
                  showSearch={false}
                  allowClear={false}
                  size='middle'
                  ref={selectRef}
                  style={{ width: '100%', height: '58px', marginRight: '10px', color: '#00000080' }}
                  placeholder="Select Multi Year Deal"
                  optionFilterProp="children"
                  value={multiyearDealcheck}
                  disabled={true}
                  onSelect={(value: string) => handleChangedValue('multiyearDealcheck', value)}
                  filterOption={(input: any, option: any) =>
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={multiyearDealcheckOptions}
                >
                </Select>
              </FloatLabel>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
                <FloatLabel label="Number Of Years *" value={yearsofDeal}>
                  <Select
                    showSearch={false}
                    allowClear={false}
                    size='middle'
                    ref={selectRef}
                    style={{ width: 400, height: 58, marginRight: '10px' }}
                    
                    optionFilterProp="children"
                    value={yearsofDeal}
                    disabled = {true}
                    onSelect={(value: string) => handleChangedValue('yearsofDeal', value)}
                    filterOption={(input: any, option: any) =>
                      option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    options={noOfYearsOptions || []}
                  >
                  </Select>
                </FloatLabel>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
              <FloatLabel label="Choose Date Range Type? *" value={datetype}>
                <Select
                  showSearch={false}
                  allowClear={false}
                  size='middle'
                  ref={selectRef}
                  style={{ width: 400, height: 58, marginRight: '10px' }}
                  placeholder="Select Date Range Type"
                  optionFilterProp="children"
                  value={datetype}
                  disabled
                  onSelect={(value: string) => handleChangedValue('datetype', value)}
                  filterOption={(input: any, option: any) =>
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={datetypeOptions}
                >
                </Select>
              </FloatLabel>
            </div>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <div>
                <Space direction="vertical" size={12} style={{ marginBottom: 8 }}>
                  <label>Start Date  -  End Date *</label>
                  <RangePicker
                    value={[dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]}
                    disabledDate={(current: any) => current && current < moment(startDate) || current > moment(endDate)}
                    size="middle"
                    // inputReadOnly ={true}
                    allowClear={false}
                    onChange={(date: any, dateString: any) => { handleChangedValue('customDateSelection', dateString) }}
                    disabled={isCustomRangeDisabled}
                  />
                </Space>
                <>
                  {
                    isCustomDateRange && <div style={{ color: '#034ea2' }}>Note: Please select date range between Sow Start Date({startDate}) and Sow End Date({endDate})</div>
                  }

                </>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', justifyContent: 'center', width: 'calc(100% - 20px)', backgroundColor: "#f5f8fa", padding: '10px 0px 10px 0px', color: '#000', margin: '10px' }}><div style={{ font: 'bold 14px / 20px "Nunito Sans"' }}>BU Section</div>&nbsp;
        </div>
      </div>
      <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Business Unit *" value={selectedBuData}>
            <Select
              showSearch
              allowClear={false}
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              // placeholder="Select  BU"
              optionFilterProp="children"
              value={selectedBuData}
              onSelect={(value: string) => handleChangedValue('bu', value)}

              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              disabled ={!buSectionEditable}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...bulist].sort((a: any, b: any) => a.localeCompare(b)).map((item: any) => ({ value: item }))}
            >
            </Select>
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Department *" value={selectedDepartment}>
            <Select
              showSearch
              allowClear={false}
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              // placeholder="Select  Department"
              optionFilterProp="children"
              value={selectedDepartment}
              onSelect={(value: string) => handleChangedValue('department', value)}
              disabled={buSectionEditable?burelatedfields:true}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...departmentList].sort((a: any, b: any) => a.localeCompare(b)).map((item: any) => ({ value: item }))}
            >
            </Select>
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Sub Department *" value={selectedSubDepartment}>
            <Select
              showSearch
              allowClear={false}
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%', height: 58, marginRight: '10px' }}
              // placeholder="Select  Sub Department"
              optionFilterProp="children"
              value={selectedSubDepartment}
              onSelect={(value: string) => handleChangedValue('subDepartment', value)}
              disabled={buSectionEditable? subDepartmentFiled: true}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input: any, option: any) =>
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={[...subDepartmentList].sort((a: any, b: any) => a.localeCompare(b)).map((item: any) => ({ value: item }))}
            >
            </Select>
          </FloatLabel>
        </div>
      </div>
      <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <FloatLabel label="Class Code *" value={classCode}>
            <Input
              value={classCode}
              id="classCode"
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', color: '#00000080', paddingTop: '15px' }}
              required={true}
              disabled={true}
              onChange={(e) => handleChangedValue('classCode', e.target.value)}
            />
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <FloatLabel label="TCV Split *" value={tcvSplit}>
            <Input
              type='text'
              min={0}
              step={0.01}
              onKeyDown={handlekeyDown_TCVSplit}
              onWheel={(e) => {
                const target = e.target as HTMLInputElement;
                target.blur()
              }}
              value={tcvSplit}
              id="tcvSplit"
              size='middle'
              style={{ width: '100%', height: 58, marginRight: '10px', paddingTop: '15px' }}
              required={true}
              disabled={false}
              onChange={(e) => handleChangedValue('tcvSplit', e.target.value)}
              onBlur={(e) => {
                setTcvSplit(get2decimalvalueNumber(e.target.value))}
              }
            />
          </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12'>
          <Checkbox label="Primary Class Code" checked={primaryclasscode} onChange={(checked: boolean) => setPrimaryclasscode(checked)} />
        </div>
      </div>
      <div className="form-buttons" style={{ display: 'flex', justifyContent: 'end', marginBottom: '25px' }}>
        <Button label={buSectionEditable?"Add":"Update"} disabled={!isAddbuttonEnabled()} type="submit" onClick={addBuData} />
      </div>
      <div>
        <Table
          className='table-style'
          columns={columns} dataSource={buSecData} scroll={{ x: 'max-content' }} />
      </div>
      <div className="form-buttons" style={{ display: 'flex', justifyContent: 'end', marginTop:'20px' }}>
        <Button label="Cancel" type="cancel" onClick={onCancel} height='40px' />
        <Button label={orderDashboardData.workOrderModal.type==="create"?"CREATE WORK ORDER": "UPDATE WORK ORDER"} width='200px' height='40px' disabled={!isSubmitbuttonEnabled()} type="submit" onClick={()=>handleSubmit()} />
      </div>
      {/* </form> */}
      <InvoiceScheduleModal
        open={showInvoiceScheduleModal}
        onCancel={() => setShowInvoiceScheduleModal(false)}
        onSave={handleInvoiceScheduleSave}
        totalContractValue={totalcontractvalue}
        currency={selectedCurrency}
        initialSchedule={invoiceSchedule}
      />
    </div>
    </Spin>
  );
};

export default CreateOrderRequestForm;